import {
  ADD_DOCTOR,
  ADD_DOCTOR_FROM_EXISTING_USER,
  GET_DOCTORS_FOR_DEPT,
  GET_DOCTORS_FOR_HC_ORG,
  GET_DOCTORS_FOR_ORG,
  GET_USER_BY_EMAIL,
  REMOVE_DOCTOR_FROM_DEPT,
  TOGGLE_DOCTOR_HEAD,
  TOGGLE_DOCTOR_PRIVILEGES,
  GET_ORG_DOCTORS,
} from "./DoctorActions";

const initialState = {
  doctors: [],
  doctor: {},
  user: null,
};

/**
 * reducer function to update state based on action
 * @param state: current state of the reducer
 * @param action: action to perform on the data
 * @returns {({doctors: *[], doctor: {}, user: null} & {doctors: ([]|null|*)})|({doctors: *[], doctor: {}, user: null} & {user})|({doctors: *[], doctor: {}, user: null} & {doctor: *})|{doctors: *[], doctor: {}, user: null}}
 * @constructor
 */
const DoctorReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_DOCTOR:
      return Object.assign({}, state, {
        doctor: action.doctor,
      });
    case ADD_DOCTOR_FROM_EXISTING_USER:
      return Object.assign({}, state, {
        doctor: action.doctor,
      });

    case GET_DOCTORS_FOR_ORG:
      return Object.assign({}, state, {
        doctors: action.doctors,
      });

    case GET_ORG_DOCTORS:
      return Object.assign({}, state, {
        doctors: action.doctors,
      });

    case GET_DOCTORS_FOR_HC_ORG:
      return Object.assign({}, state, {
        doctors: action.doctors,
      });

    case GET_DOCTORS_FOR_DEPT:
      return Object.assign({}, state, {
        doctors: action.doctors,
      });

    case REMOVE_DOCTOR_FROM_DEPT:
      return Object.assign({}, state, {
        doctor: action.doctor,
      });

    case TOGGLE_DOCTOR_HEAD:
      return Object.assign({}, state, {
        doctor: action.doctor,
      });

    case TOGGLE_DOCTOR_PRIVILEGES:
      return {
        ...state,
      };

    case GET_USER_BY_EMAIL:
      return Object.assign({}, state, {
        user: action.user,
      });

    default:
      return state;
  }
};

export default DoctorReducer;
